var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 6.7616H20.25M8.25 12.0116H20.25M8.25 17.2616H20.25M3.75 6.7616H3.7575V6.7691H3.75V6.7616ZM4.125 6.7616C4.125 6.9687 3.95711 7.1366 3.75 7.1366C3.54289 7.1366 3.375 6.9687 3.375 6.7616C3.375 6.55449 3.54289 6.3866 3.75 6.3866C3.95711 6.3866 4.125 6.55449 4.125 6.7616ZM3.75 12.0116H3.7575V12.0191H3.75V12.0116ZM4.125 12.0116C4.125 12.2187 3.95711 12.3866 3.75 12.3866C3.54289 12.3866 3.375 12.2187 3.375 12.0116C3.375 11.8045 3.54289 11.6366 3.75 11.6366C3.95711 11.6366 4.125 11.8045 4.125 12.0116ZM3.75 17.2616H3.7575V17.2691H3.75V17.2616ZM4.125 17.2616C4.125 17.4687 3.95711 17.6366 3.75 17.6366C3.54289 17.6366 3.375 17.4687 3.375 17.2616C3.375 17.0545 3.54289 16.8866 3.75 16.8866C3.95711 16.8866 4.125 17.0545 4.125 17.2616Z",
    stroke: "#A0B5B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryInactive);
export default __webpack_public_path__ + "static/media/Category_inactive.2e7a97f7b8d6aef6173a5893e5aa5b58.svg";
export { ForwardRef as ReactComponent };